/* Meravero — comportamiento compartido de las secciones "mer-".
   Se carga una sola vez con defer. Cada init comprueba que su
   elemento exista, asi el mismo archivo sirve en todas las paginas. */
(function () {
  'use strict';

  function initFaq(root) {
    var items = (root || document).querySelectorAll('.mer-faq-item:not([data-mer-ready])');
    items.forEach(function (item) {
      item.setAttribute('data-mer-ready', '');
      var btn = item.querySelector('.mer-faq-q');
      var panel = item.querySelector('.mer-faq-a');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var group = item.closest('.mer-faq-list') || document;
        var isOpen = item.classList.contains('is-open');

        group.querySelectorAll('.mer-faq-item.is-open').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          other.querySelector('.mer-faq-a').style.maxHeight = null;
          other.querySelector('.mer-faq-q').setAttribute('aria-expanded', 'false');
        });

        if (isOpen) {
          item.classList.remove('is-open');
          panel.style.maxHeight = null;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  var observer = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mer-reveal:not([data-mer-ready])');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.setAttribute('data-mer-ready', '');
        el.classList.add('is-visible');
      });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
    }

    els.forEach(function (el) {
      el.setAttribute('data-mer-ready', '');
      observer.observe(el);
    });
  }

  function initAll(root) {
    initFaq(root);
    initReveals(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  /* El editor de Shopify vuelve a pintar una seccion cuando el usuario
     la edita: hay que re-inicializar solo esa parte. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
